import React, { useEffect } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider } from "styled-components";
import { LoadingSpinner } from "ctech-react-components";

import { loadInitialConfig } from "config/appConfig";
import Routes from "routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "styles/reactToastifyOverrides.css";

import AuthTokenSync from "components/AuthTokenSync";
import AppProvider from "context";

import store from "store";

import * as themeConfig from "styles/themes";
import GlobalStyle from "styles/global";
import { useAppSelector } from "store/hooks";
import { clarityManager } from "libs/clarity";

function Spinner() {
  const { isSpinnerVisible } = useAppSelector((state) => state.appConfig);

  return <LoadingSpinner isSpinnerVisible={isSpinnerVisible} />;
}

const App = () => {
  useEffect(() => {
    loadInitialConfig();
  }, []);

  useEffect(() => {
    clarityManager.init();
  }, []);

  return (
    <ReduxProvider store={store}>
      <AppProvider>
        <MuiThemeProvider theme={themeConfig.defaultTheme}>
          <ThemeProvider theme={themeConfig.defaultTheme}>
            <GlobalStyle />
            <AuthTokenSync>
              <Spinner />
              <Routes />
              <ToastContainer />
            </AuthTokenSync>
          </ThemeProvider>
        </MuiThemeProvider>
      </AppProvider>
    </ReduxProvider>
  );
};

export default App;
